import { render, staticRenderFns } from "./callus.vue?vue&type=template&id=291369a1&scoped=true"
import script from "./callus.vue?vue&type=script&lang=js"
export * from "./callus.vue?vue&type=script&lang=js"
import style0 from "./callus.vue?vue&type=style&index=0&id=291369a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291369a1",
  null
  
)

export default component.exports